/**
 * Obtiene el array de novedades desde cualquier forma habitual del BFF / API remoto.
 */
export function extractNovedadesResultadosRawList(raw) {
  let data = raw;
  if (data == null) return [];
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return [];
    }
  }
  if (Array.isArray(data)) return data;

  const keyCandidates = [
    'novedades', 'Novedades',
    'listaNovedades', 'ListaNovedades',
    'resultados', 'Resultados',
    'elementos', 'Elementos',
    'content', 'Content',
    'items', 'Items',
    'data', 'Data',
    'result', 'Result',
    'value', 'Value',
  ];

  const pickFromObject = (obj) => {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return [];
    for (const k of keyCandidates) {
      const v = obj[k];
      if (Array.isArray(v)) return v;
    }
    return [];
  };

  let list = pickFromObject(data);
  if (list.length) return list;

  const nestedRoots = ['data', 'Data', 'result', 'Result', 'payload', 'Payload', 'response', 'Response'];
  for (const nr of nestedRoots) {
    const inner = data[nr];
    if (inner == null || typeof inner !== 'object') continue;
    list = pickFromObject(inner);
    if (list.length) return list;
    if (Array.isArray(inner)) return inner;
  }

  const looksNovedadItem = (x) => x && typeof x === 'object' && (
    'idNovedad' in x || 'IdNovedad' in x
    || 'fechaNovedad' in x || 'FechaNovedad' in x
  );

  const firstMatchingArray = (obj) => {
    if (!obj || typeof obj !== 'object') return [];
    for (const v of Object.values(obj)) {
      if (!Array.isArray(v) || v.length === 0) continue;
      if (looksNovedadItem(v[0])) return v;
    }
    for (const v of Object.values(obj)) {
      if (Array.isArray(v) && v.length > 0 && looksNovedadItem(v[0])) return v;
    }
    return [];
  };

  list = firstMatchingArray(data);
  if (list.length) return list;
  if (data.data && typeof data.data === 'object') {
    list = firstMatchingArray(data.data);
    if (list.length) return list;
  }

  return [];
}

/** Estado cerrado: no se puede volver a marcar como confirmada desde la grilla. */
export function esNovedadConfirmada(liquidacion) {
  if (!liquidacion || typeof liquidacion !== 'object') return false;

  const detalle = String(
    liquidacion.detalleEstadoNovedad
    ?? liquidacion.DetalleEstadoNovedad
    ?? liquidacion.estado
    ?? liquidacion.Estado
    ?? ''
  ).trim().toLowerCase();

  if (!detalle) return false;

  return (
    detalle.includes('confirmad')
    || detalle.includes('anulad')
    || detalle.includes('eliminad')
    || detalle.includes('cancelad')
  );
}

/** Checkbox y acción "Marcar confirmadas" solo en novedades aún no cerradas. */
export function puedeConfirmarNovedad(liquidacion) {
  return !esNovedadConfirmada(liquidacion);
}

/**
 * Normaliza propiedades de una novedad a camelCase para los componentes React.
 */
export function normalizeNovedadItem(item) {
  if (!item || typeof item !== 'object') return item;
  return {
    ...item,
    idNovedad: item.idNovedad ?? item.IdNovedad,
    idLiquidacion: item.idLiquidacion ?? item.IdLiquidacion,
    importe: item.importe ?? item.Importe ?? item.importeNovedad ?? item.ImporteNovedad,
    importeNovedad: item.importeNovedad ?? item.ImporteNovedad ?? item.importe ?? item.Importe,
    fechaNovedad: item.fechaNovedad ?? item.FechaNovedad,
    idSeller: item.idSeller ?? item.IdSeller,
    sellerRazonSocial: item.sellerRazonSocial ?? item.SellerRazonSocial ?? item.seller ?? item.Seller,
    observaciones: item.observaciones ?? item.Observaciones,
    ordenDeReferencia: item.ordenDeReferencia ?? item.OrdenDeReferencia,
    idTipoNovedad: item.idTipoNovedad ?? item.IdTipoNovedad,
    detalleTipoNovedad: item.detalleTipoNovedad ?? item.DetalleTipoNovedad ?? item.tipoNovedadDescripcion ?? item.TipoNovedadDescripcion,
    idEstadoNovedad: item.idEstadoNovedad ?? item.IdEstadoNovedad,
    detalleEstadoNovedad: item.detalleEstadoNovedad ?? item.DetalleEstadoNovedad ?? item.estado ?? item.Estado,
    idSubTipoNovedad: item.idSubTipoNovedad ?? item.IdSubTipoNovedad,
    detalleSubTipoNovedad: item.detalleSubTipoNovedad ?? item.DetalleSubTipoNovedad ?? item.descripcionSubTipoNovedad ?? item.DescripcionSubTipoNovedad,
    idEstado: item.idEstado ?? item.IdEstado,
    descripcionConceptoNovedad: item.descripcionConceptoNovedad ?? item.DescripcionConceptoNovedad,
    seller: item.seller ?? item.Seller ?? item.sellerRazonSocial ?? item.SellerRazonSocial,
    enPreparacion: item.enPreparacion ?? item.EnPreparacion,
    muestraBoton: item.muestraBoton ?? item.MuestraBoton,
    comentarios: item.comentarios ?? item.Comentarios ?? '',
    porcentajePenalidad: item.porcentajePenalidad ?? item.PorcentajePenalidad ?? item.porcentaje ?? item.Porcentaje,
  };
}
